import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";
const LandingPage = lazy(() =>
  import("../components/landing-page/LandingPage").then((mod) => ({ default: mod.default }))
);
const GenerateLayout = lazy(() =>
  import("../components/generate/GenerateLayout").then((mod) => ({ default: mod.default }))
);
const RelateLayout = lazy(() =>
  import("../components/relate/RelateLayout").then((mod) => ({ default: mod.default }))
);
const OrchestrateLayout = lazy(() =>
  import("../components/orchestrate/OrchestrateLayout").then((mod) => ({ default: mod.default }))
);
const WinLayout = lazy(() =>
  import("../components/win/WinLayout").then((mod) => ({ default: mod.default }))
);
const PlatformLayout = lazy(() =>
  import("../components/platform/PlatformLayout").then((mod) => ({ default: mod.default }))
);
const SetupLayout = lazy(() =>
  import("../components/setup/SetupLayout").then((mod) => ({ default: mod.default }))
);
const ConfigLayout = lazy(() =>
  import("../components/crm-config/CrmConfigLayout").then((mod) => ({ default: mod.default }))
);

// ==========================================================================================================
const index = () => {
  return (
    // <BrowserRouter>
    <Routes>
      <Route
        index
        path="/"
        element={
          <Suspense fallback={<div style={{ textAlign: "center" }}>Loading...</div>}>
            <LandingPage />
          </Suspense>
        }
      />
      <Route
        index
        path="/generate"
        element={
          <Suspense fallback={<div style={{ textAlign: "center" }}>Loading...</div>}>
            <GenerateLayout />
          </Suspense>
        }
      />
      <Route
        index
        path="/relate"
        element={
          <Suspense fallback={<div style={{ textAlign: "center" }}>Loading...</div>}>
            <RelateLayout />
          </Suspense>
        }
      />
      <Route
        index
        path="/orchestrate"
        element={
          <Suspense fallback={<div style={{ textAlign: "center" }}>Loading...</div>}>
            <OrchestrateLayout />
          </Suspense>
        }
      />
      <Route
        index
        path="/won"
        element={
          <Suspense fallback={<div style={{ textAlign: "center" }}>Loading...</div>}>
            <WinLayout />
          </Suspense>
        }
      />
      <Route
        index
        path="/platform"
        element={
          <Suspense fallback={<div style={{ textAlign: "center" }}>Loading...</div>}>
            <PlatformLayout />
          </Suspense>
        }
      />
      <Route
        index
        path="/setup"
        element={
          <Suspense fallback={<div style={{ textAlign: "center" }}>Loading...</div>}>
            <SetupLayout />
          </Suspense>
        }
      />
      <Route
        index
        path="/config"
        element={
          <Suspense fallback={<div style={{ textAlign: "center" }}>Loading...</div>}>
            <ConfigLayout />
          </Suspense>
        }
      />
    </Routes>
    // </BrowserRouter>
  );
};

export default index;
